import React from 'react';
import { useAppSelector } from 'hooks';
import { Button as RSButton, ButtonProps as RSButtonProps } from 'reactstrap';

import Spinner, { ComponentProps as SpinnerProps } from '~components/Spinner';

import { selectUserTags } from '~main/selectors/login';

// TRIVIAL CHANGE FOR VERIFYING AI-TEST CREATION IN CI/CD PIPELINE - CHRIS

export interface ButtonProps extends RSButtonProps {
  /** Authorization tag that restricts button visibility to users with this tag */
  authTag?: string;
  /** Data attribute for testing */
  dataCy?: string;
  /** Shows a loading spinner and disables the button when true */
  loading?: boolean;
  /** Custom spinner props override */
  spinnerProps?: SpinnerProps;
}

const Button: React.FC<ButtonProps> = ({ authTag, dataCy, loading = false, children, spinnerProps, ...props }) => {
  const tags = useAppSelector(selectUserTags);
  const visible = !authTag || (authTag && tags.includes(authTag));

  if (!visible) return null;

  return (
    <RSButton data-cy={dataCy} disabled={loading || props.disabled} {...props}>
      {loading ? (
        <Spinner
          loading={true}
          type="beat"
          size={10}
          color={props.color === 'light' ? 'dark' : 'white'}
          className="m-2"
          {...spinnerProps}
        />
      ) : (
        children
      )}
    </RSButton>
  );
};

export default React.memo(Button);
